// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__fHJmX","errorLogs":"styles_errorLogs__2Daap"};